module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/question_button-9274b23ec30c83b6179b03abd794f645.svg";